import loadScript from '../util/loader';

const selectors = {
  videoPlayer: '[data-video]',
  modelViewer: '[data-model]',
  dataType: 'data-type',
  dataMediaId: 'data-media-id',
  dataVideoLooping: 'data-video-looping',
  dataYoutubeId: 'data-youtube-id',
  productMediaWrapper: '[data-product-single-media-wrapper]',
  productMediaContainer: '[data-product-single-media-group]',
  classMediaHidden: 'media--hidden',
};
theme.mediaInstances = {};
class Video {
  constructor(section) {
    this.section = section;
    this.container = section.container;
    this.id = section.id;
    this.players = {};
    this.init();
  }

  init() {
    const playerElements = this.container.querySelectorAll(selectors.videoPlayer);
    let hasYouTube = false;
    let hasNative = false;
    for (let i = 0; i < playerElements.length; i++) {
      const newPlayerID = playerElements[i].getAttribute('id');
      const newPlayerType = playerElements[i].getAttribute(selectors.dataType);
      const newPlayerMediaId = playerElements[i].getAttribute(selectors.dataMediaId);
      this.players[newPlayerID] = {};
      this.players[newPlayerID].id = newPlayerID;
      this.players[newPlayerID].type = newPlayerType;
      this.players[newPlayerID].mediaId = newPlayerMediaId;
      this.players[newPlayerID].container = playerElements[i];
      this.players[newPlayerID].element = playerElements[i].querySelector('iframe, video');
      if (!this.players[newPlayerID].element) return;
      if (newPlayerType === 'external_video') {
        const youtubeID = playerElements[i].getAttribute(selectors.dataYoutubeId);
        this.players[newPlayerID].externalID = youtubeID;
        hasYouTube = true;
      } else if (newPlayerType === 'video') {
        hasNative = true;
      }
    }
    if (hasNative) {
      if (window.isPlyrLoaded) {
        this.nativeInitCallback();
      } else {
        // Load Plyr
        const videoLoad = {
          name: 'video-ui',
          version: '1.0',
        };
        loadScript(videoLoad).then(() => this.nativeInitCallback());
      }
    }

    if (hasYouTube) {
      if (window.isYoutubeAPILoaded) {
        this.youTubeInitCallback();
      } else {
        // Load Youtube API
        loadScript({url: 'https://www.youtube.com/iframe_api'}).then(() => this.youTubeInitCallback());
      }
    }
  }

  youTubeInitCallback() {
    for (const currentPlayerID in this.players) {
      if (this.players[currentPlayerID].type === 'external_video') {
        const currentPlayer = this.players[currentPlayerID];
        const enableLooping = this.players[currentPlayerID].container.closest(`[${selectors.dataVideoLooping}]`).getAttribute(selectors.dataVideoLooping) === 'true';
        const defaultYoutubeOptions = {
          playerVars: {
            cc_load_policy: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            autohide: 0,
            controls: 1,
            branding: 0,
            showinfo: 0,
            rel: 0,
            fs: 0,
            wmode: 'opaque',
          },
          events: {
            onStateChange: (e) => {
              if (e.data === 0 && enableLooping) e.target.seekTo(0);
              const currentMediaElem = e.target.getIframe().closest(`[${selectors.dataMediaId}]`);
              let currentMediaId = '';
              if (currentMediaElem) {
                currentMediaId = currentMediaElem.getAttribute(selectors.dataMediaId);
              }
              if (e.data === 1) this.pauseOtherMedia(currentMediaId);
            },
          },
        };

        const currentYoutubeOptions = {...defaultYoutubeOptions};
        currentYoutubeOptions.videoId = currentPlayer.externalID;

        YT.ready(() => {
          this.players[currentPlayerID].player = new YT.Player(currentPlayer.element, currentYoutubeOptions);

          window.isYoutubeAPILoaded = true;

          this.players[currentPlayerID].container.addEventListener('mediaHidden', (event) => this.onHidden(event, true));
          this.players[currentPlayerID].container.addEventListener('xrLaunch', (event) => this.onHidden(event, true));
          this.players[currentPlayerID].container.addEventListener('mediaVisible', (event) => this.onVisible(event, true));
        });
      }
    }
  }

  nativeInitCallback() {
    for (const currentPlayerID in this.players) {
      if (this.players[currentPlayerID].type === 'video') {
        const currentPlayer = this.players[currentPlayerID];
        const enableLooping = this.players[currentPlayerID].container.closest(`[${selectors.dataVideoLooping}]`).getAttribute(selectors.dataVideoLooping) === 'true',
          plyrOptions = {
            loop: {active: enableLooping},
            focusOnPlay: true,
          };
        this.players[currentPlayerID].player = new Shopify.Plyr(currentPlayer.element, plyrOptions);
        currentPlayer.element.addEventListener('play', (event) => {
          const currentMediaElem = event.target.closest(`[${selectors.dataMediaId}]`);
          let currentMediaId = '';
          if (currentMediaElem) {
            currentMediaId = currentMediaElem.getAttribute(selectors.dataMediaId);
          }
          this.pauseOtherMedia(currentMediaId);
        });

        window.isPlyrLoaded = true;

        this.players[currentPlayerID].container.addEventListener('mediaHidden', (event) => this.onHidden(event, false));
        this.players[currentPlayerID].container.addEventListener('xrLaunch', (event) => this.onHidden(event, false));
        this.players[currentPlayerID].container.addEventListener('mediaVisible', (event) => this.onVisible(event, false));
      }
    }
  }

  onHidden(event, playerYT = false) {
    if (typeof event.target.dataset.playerId !== 'undefined') {
      const newID = event.target.dataset.playerId;
      const newPlayer = this.players[newID];
      if (playerYT === true && newPlayer.player && newPlayer.player.pauseVideo) {
        newPlayer.player.pauseVideo();
      } else if (newPlayer.player && newPlayer.player.pause) {
        newPlayer.player.pause();
      }
    }
  }

  onVisible(event, playerYT = false) {
    if (window.theme.touched) return;
    if (typeof event.target.dataset.playerId !== 'undefined') {
      const newID = event.target.dataset.playerId;
      const newPlayer = this.players[newID];
      if (playerYT === true && newPlayer.player && newPlayer.player.playVideo) {
        newPlayer.player.playVideo();
      } else if (newPlayer.player && newPlayer.player.play) {
        newPlayer.player.play();
      }
    }
  }

  pauseOtherMedia(mediaId) {
    const mediaIdString = `[${selectors.dataMediaId}="${mediaId}"]`;
    const currentMedia = document.querySelector(`${selectors.productMediaWrapper}${mediaIdString}`);
    const otherMedia = document.querySelectorAll(`${selectors.productMediaWrapper}:not(${mediaIdString})`);
    currentMedia.classList.remove(selectors.classMediaHidden);
    if (otherMedia.length) {
      otherMedia.forEach((element) => {
        element.dispatchEvent(new CustomEvent('mediaHidden'));
        element.classList.add(selectors.classMediaHidden);
      });
    }
  }
}
export default Video;
